export const roleBasedDegreeListConvertion = ({
  listOfDegree,
  parentNameParam = 'degree',
  parentValueParam = 'id',
  childrenValueParam = 'degreeStreamMapId',
  pathName = 'degreeStreamMap',
}) => {
  return (
    listOfDegree?.length &&
    listOfDegree?.map(item => {
      return {
        title: item[parentNameParam],
        value: item[parentValueParam],
        children: item[pathName]?.map(data => {
          return {
            title:
              pathName === 'streams'
                ? item?.shortForm
                  ? `${item?.shortForm} - ${data?.name}`
                  : data?.name
                : item?.shortForm
                ? `${item?.shortForm} - ${data?.stream?.name}`
                : data?.stream?.name,
            value: data[childrenValueParam],
          }
        }),
      }
    })
  )
}
